import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Save } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DOCS = [
  { key: "terms", label: "Regulamin", publicPath: "/regulamin" },
  { key: "privacy", label: "Polityka Prywatności", publicPath: "/polityka-prywatnosci" },
  { key: "dpa", label: "Umowa Powierzenia Danych (DPA)", publicPath: "/umowa-powierzenia-danych" },
];

export default function AdminLegalPage() {
  const [content, setContent] = useState({ terms: "", privacy: "", dpa: "" });
  const [updatedAt, setUpdatedAt] = useState({});
  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState(null);

  const fetchContent = () => {
    setLoading(true);
    axios.get(`${API}/admin/legal`, { withCredentials: true })
      .then((res) => {
        setContent({
          terms: res.data.terms?.content || "",
          privacy: res.data.privacy?.content || "",
          dpa: res.data.dpa?.content || "",
        });
        setUpdatedAt({ terms: res.data.terms?.updated_at, privacy: res.data.privacy?.updated_at, dpa: res.data.dpa?.updated_at });
      })
      .catch(() => toast.error("Błąd ładowania"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchContent();
  }, []);

  const handleSave = async (key) => {
    setSavingKey(key);
    try {
      await axios.put(`${API}/admin/legal/${key}`, { content: content[key] }, { withCredentials: true });
      toast.success("Zapisano");
      fetchContent();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Błąd zapisu");
    } finally {
      setSavingKey(null);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500"></div></div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Dokumenty prawne</h1>
        <p className="text-slate-500">
          Zwykły tekst (bez HTML) — wyświetlany 1:1 na stronach publicznych. Dopóki pole jest puste, strona pokazuje "nie został jeszcze uzupełniony", nie żaden domyślny szablon.
        </p>
      </div>

      {DOCS.map(({ key, label, publicPath }) => (
        <Card key={key}>
          <CardHeader className="pb-3">
            <div className="flex items-center justify-between flex-wrap gap-2">
              <CardTitle className="text-base">{label}</CardTitle>
              <a href={publicPath} target="_blank" rel="noopener noreferrer" className="text-xs text-emerald-700 hover:underline">
                Podgląd: {publicPath}
              </a>
            </div>
          </CardHeader>
          <CardContent className="space-y-3">
            <Textarea
              rows={12}
              placeholder={`Wklej treść dokumentu "${label}"...`}
              value={content[key]}
              onChange={(e) => setContent((c) => ({ ...c, [key]: e.target.value }))}
            />
            <div className="flex items-center justify-between">
              {updatedAt[key] && (
                <p className="text-xs text-slate-400">Ostatnia aktualizacja: {new Date(updatedAt[key]).toLocaleString("pl-PL")}</p>
              )}
              <Button onClick={() => handleSave(key)} disabled={savingKey === key} size="sm" className="ml-auto">
                <Save className="w-4 h-4 mr-1.5" />
                Zapisz
              </Button>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
